import WatchProfile from '@/components/watch/profile/WatchProfile'
import WatchProfilePersonalInformation from '@/components/watch/profile/watchProfile/WatchProfilePersonalInformation'
import WatchProfileContacts from '@/components/watch/profile/watchProfile/WatchProfileContacts'
import WatchProfileMedicalInformation from '@/components/watch/profile/watchProfile/WatchProfileMedicalInformation'
import WatchProfileFamilyInformation from '@/components/watch/profile/watchProfile/WatchProfileFamilyInformation'
import WatchProfileSSNumbers from '@/components/watch/profile/watchProfile/WatchProfileSSNumbers'
import WatchProfileInsurances from '@/components/watch/profile/watchProfile/WatchProfileInsurances'

export default [
	{
		path: 'profile/',
		component: WatchProfile,
		props: (route) => ({
			user_uid: route.params.user_uid,
			watch_id: route.params.watch_id
		}),
		children: [
			{
				path: '',
				name: 'WatchProfile',
				component: WatchProfilePersonalInformation,
				props: (route) => ({
					user_uid: route.params.user_uid,
					watch_id: route.params.watch_id
				})
			},
			{
				path: 'contacts',
				name: 'WatchProfileContacts',
				component: WatchProfileContacts,
				props: (route) => ({
					user_uid: route.params.user_uid,
					watch_id: route.params.watch_id
				})
			},
			{
				path: 'medical-information',
				name: 'WatchProfileMedicalInformation',
				component: WatchProfileMedicalInformation,
				props: (route) => ({
					user_uid: route.params.user_uid,
					watch_id: route.params.watch_id
				})
			},
			{
				path: 'family-information',
				name: 'WatchProfileFamilyInformation',
				component: WatchProfileFamilyInformation,
				props: (route) => ({
					user_uid: route.params.user_uid,
					watch_id: route.params.watch_id
				})
			},
			{
				path: 's-s-numbers',
				name: 'WatchProfileSSNumbers',
				component: WatchProfileSSNumbers,
				props: (route) => ({
					user_uid: route.params.user_uid,
					watch_id: route.params.watch_id
				})
			},
			{
				path: 'insurances',
				name: 'WatchProfileInsurances',
				component: WatchProfileInsurances,
				props: (route) => ({
					user_uid: route.params.user_uid,
					watch_id: route.params.watch_id
				})
			},
		]
	}
]



// WEBPACK FOOTER //
// ./src/router/modules/watch/profile.js